import { useCampaignInfoByProvider } from '#api/new/campaigns/utils/campaignUtils.js';
import { useShowConsumerCampaignById } from '@givebacks/api/store';
import { useCrowdFundingTranslations } from 'core/Hooks';
import { Stack, Title } from 'ui';
import { randomId } from 'ui/Hooks';

import { useRecentCampaignDonations } from '../../../../api/new/donations/get';
import { CampaignDonorCard } from './CampaignDonorCard';

interface Props {
  campaign_uuid: string;
}

export const RecentCampaignDonations = ({ campaign_uuid }: Props) => {
  const { causeId, campaignId } = useCampaignInfoByProvider();
  const { data: campaign } = useShowConsumerCampaignById({ causeId, campaignId });
  // TODO: This needs to be updated to support the new consumer campaign api routes
  const { data, isLoading } = useRecentCampaignDonations({
    campaignId: campaign_uuid,
    causeId: campaign?.cause_id,
  });
  const { t } = useCrowdFundingTranslations(campaign?.cause_id);

  if (isLoading || data?.carts === undefined || data?.carts?.length < 1) return null;

  return (
    <Stack>
      <Stack>
        <Title order={2} mb={4}>{`Recent ${t('Donations')}`}</Title>

        {data?.carts?.map((donation) => (
          <CampaignDonorCard key={`${donation.subtotal}-${randomId()}`} donation={donation} />
        ))}
      </Stack>
    </Stack>
  );
};
